import { useContext } from 'react'
import {
  UserQueryContext,
  UserQueryContextValue
} from '../providers/UserQueryProvider'

export function useUserQuery(): UserQueryContextValue | undefined {
  return useContext(UserQueryContext)
}
